/**
 * Shared focus-trap utilities for modal overlays.
 *
 * Keeps Tab/Shift+Tab cycling inside a dialog container. Consumers attach a
 * keydown handler on the dialog panel and call `trapFocus` when the key is
 * "Tab". The trap only intercepts keys dispatched INSIDE the container —
 * initial focus must be placed within the dialog by the consumer or the page
 * behind stays focused (see Dialog.tsx / PlexCredentialModal.tsx usage).
 */
import type { KeyboardEvent } from "react";

export const FOCUSABLE_SELECTOR =
  "button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";

export const trapFocus = (container: HTMLElement, event: KeyboardEvent): void => {
  const focusable = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
  if (focusable.length === 0) return;

  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  const active = document.activeElement;

  if (event.shiftKey && active === first) {
    event.preventDefault();
    last?.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first?.focus();
  }
};
